import { PublicView } from "@/components/publicView";

export function PublicViewPage() {
  return <PublicView />;
}

export default PublicViewPage;
